/* eslint-disable no-useless-escape */
/* eslint-disable jsx-control-statements/jsx-jcs-no-undef */
/* eslint-disable no-unused-expressions */
import {
  ROUTER_BASE_PATH,
  DESKTOP_ROUTER_BASE_PATH
} from 'AccountsConstants/routes'
import { checkMobileDevice } from './validator'
import { isTripDetailsPage } from './Trips/TripDetails'

export const onlyNumbersRegex = /^[0-9]+$/
export const onlyAlphabetsSpaceRegex = /^[A-Za-z\s]+$/

export const makeArrayUnique = (arr, key) => {
  const returnVal = []
  const indexingArr = []
  for (const arrEl of arr) {
    if (indexingArr.indexOf(arrEl[key]) < 0) {
      returnVal.push(arrEl)
      indexingArr.push(arrEl[key])
    }
  }
  return returnVal
}
export const objectHasKey = (obj, key) => {
  const keys = Object.keys(obj)
  return keys.indexOf(key) > -1
}

export const convertToSafariCompatibleDate = str => (str && typeof str === 'string' ? str.replace('+0000', '4Z') : str)
const getEpochSecs = offset => (offset.split('.').length > 1 ?
  (parseFloat(`.${offset.split('.')[1]}`, 10) +
    parseInt(offset.split('.')[0], 10)) *
  3600000 :
  parseInt(offset, 10) * 3600000)
export const getEpochAdjustedTime = (dstr, offset = '5.5', flag = true) => {
  const str = convertToSafariCompatibleDate(dstr)
  const modifiedOffset = flag ? '5.5' : offset
  const epochSecs = getEpochSecs(modifiedOffset)
  let dateTime = null
  if (str) {
    dateTime = new Date(str)
    dateTime = dateTime && dateTime !== 'Invalid Date' ? dateTime : null
    if (dateTime) {
      let timeZone = flag ? dateTime.getTimezoneOffset() : 0
      timeZone *= 60000 // converting to milliseconds
      let dateTimeInMS = dateTime.getTime() + timeZone
      if (
        !Number.isNaN(parseFloat(modifiedOffset, 0)) &&
        parseFloat(modifiedOffset, 0) > 0
      ) {
        dateTimeInMS += epochSecs
      } else if (
        !Number.isNaN(parseFloat(modifiedOffset, 10)) &&
        parseFloat(modifiedOffset, 10) < 0
      ) {
        dateTimeInMS -= epochSecs
      }
      dateTime = new Date(dateTimeInMS)
    }
  }
  return dateTime
}
export const getDateAndTime = (dstr, of, withYear) => {
  let dateTime = []
  const str = getEpochAdjustedTime(dstr, '5.5', false)
  if (str) {
    let timeStr = ''
    let dateStr = ''
    dateStr = `${str.toUTCString().substr(0, 3)}, ${str
      .toUTCString()
      .substr(8, 3)}${str.toUTCString().substr(4, 3)}`
    if (withYear) {
      dateStr = `${dateStr}, ${str.toUTCString().substr(12, 4)}`
    }
    timeStr = str.toUTCString().substr(17, 5)
    // let newMins = parseInt(timeStr.split(":")[1]) + parseFloat(`.${offset.split('.')[1]}`) * 60
    // let newHrs = parseInt(timeStr.split(":")[0]) + parseInt(offset.split('.')[0])
    // timeStr = `${newHrs > 9 ? newHrs : `0${newHrs}`}:${newMins > 9 ? newMins : `0${newMins}`}`
    dateTime = [dateStr, timeStr]
  } else {
    dateTime = ['--', '--']
  }
  return dateTime
}

export const showTrackerText = (bookingStatus, bookingDate) => {
  let formattedBookingDate = new Date(
    convertToSafariCompatibleDate(bookingDate)
  )
  formattedBookingDate = `Booked on: ${getDateAndTime(
    formattedBookingDate,
    'dd/mm/yy',
    '/'
  )}`
  const returnVal = {
    value: formattedBookingDate,
    isHighlighted: false
  }
  if (bookingStatus === 'payment failed') {
    returnVal.value = 'View booking status >'
    returnVal.isHighlighted = true
  } else if (bookingStatus === 'payment initialized') {
    returnVal.value = 'View booking status >'
    returnVal.isHighlighted = true
  }
  return returnVal
}

export const getBasePath = () => (checkMobileDevice() ? ROUTER_BASE_PATH : DESKTOP_ROUTER_BASE_PATH)

export const htmlDecoder = str => {
  let returnString = null
  if (str) {
    const parser = new DOMParser()
    const domStr = parser.parseFromString(str, 'text/html')
    returnString = domStr.body.textContent
  }
  return returnString
}

export const getDateFormat = (dateObj, format, delim) => {
  const formattedObj = {
    yyyy: dateObj.getFullYear(),
    yy: dateObj
      .getFullYear()
      .toString()
      .substr(2, 2),
    dd: dateObj.getDate() < 10 ? `0${dateObj.getDate()}` : dateObj.getDate(),
    mm:
      dateObj.getMonth() < 9 ?
        `0${dateObj.getMonth() + 1}` :
        dateObj.getMonth() + 1,
    mon: dateObj.toString().substr(4, 3)
  }
  let dateKeys = format.split(delim)
  dateKeys = dateKeys.map(el => {
    return formattedObj[el]
  })
  return dateKeys.join(delim)
}
export const getDuration = (startDate, endDate) => {
  const eDate = convertToSafariCompatibleDate(endDate)
  const sDate = convertToSafariCompatibleDate(startDate)
  let diff = Math.abs(new Date(eDate) - new Date(sDate))
  diff = `${parseInt(diff / (1000 * 60) / 60, 10)}h ${(diff / (1000 * 60)) %
    60}m`
  return diff
}

export const validatePhone = (callbackInput, callback) => {
  const regex = /(^([+])([0-9]+)$)|(^([0-9]+)$)/
  const match = regex.test(callbackInput)
  if (match) {
    callback(false)
  } else {
    callback(true)
  }
}

export const getPageCount = (totalEls, elsPerPage) => {
  let totalPages = 1
  if (totalEls !== 0) {
    totalPages = Math.ceil(totalEls / elsPerPage)
  }
  return totalPages
}

export const keyDataReducer = (data, key) => {
  let returnDetails = null
  if (data && key) {
    const keysArray = key.split('.') || []
    returnDetails = keysArray.reduce((init, verticalName) => {
      if (!init) {
        return
      }
      const newInit =
        init && Object.prototype.hasOwnProperty.call(init, verticalName) ?
          init[verticalName] :
          null
      return newInit
    }, data)
  }
  return returnDetails
}

export const pluralize = (value = 0, text, suffix = 's') => {
  if (!value) {
    return ''
  }
  return value === 1 ? `${value} ${text}` : `${value} ${text}${suffix}`
}

export const formatCurrencyValue = num => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

export const getHotelBookingStatusText = (bookingStatus = '') => {
  const mapping = {
    p: 'Confirmed',
    b: 'Approved',
    q: 'Cancelled',
    h: 'Booking Failed',
    z: 'Payment Failed',
    j: 'Rejected',
    c: 'Hold',
    r: 'On Hold',
    k: 'Refunded',
    e: 'Elapsed'
  }
  return (mapping[bookingStatus.toLowerCase()] || '').toUpperCase()
}

export const constructHotelImage = (image, transformations) => {
  const defaultTransformation =
    'w_208,h_240,fl_progressive,e_sharpen:80,q_auto,c_fill'
  return `https://res.cloudinary.com/cleartrip/image/upload/${defaultTransformation}/hotels/places/hotels${image}`
}
export const getMonthName = date => {
  try {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ]
    return months[date.getMonth()]
  } catch (e) {
    return ''
  }
}
export const getDayName = date => {
  try {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    return days[date.getDay()]
  } catch (e) {
    return ''
  }
}

export const get24HrTime = date => {
  try {
    return `${date.getHours()}:${`0${date.getMinutes()}`.slice(-2)}hrs`
  } catch (e) {
    return ''
  }
}
export const getMeridianTime = date => {
  try {
    return `${date.getHours() === 12 ? 12 : date.getHours() % 12
    }:${`0${date.getMinutes()}`.slice(-2)}${date.getHours() > 11 ? 'PM' : 'AM'}`
  } catch (e) {
    return ''
  }
}
export const getDaysDifference = (date1, date2) => {
  try {
    const diffTime = Math.abs(date2 - date1)
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  } catch (e) {
    return ''
  }
}
export const getHoursDifference = (date1, date2) => {
  try {
    const diffTime = Math.abs(date2 - date1)
    return Math.ceil(diffTime / (1000 * 60 * 60))
  } catch (e) {
    return ''
  }
}
export const formatDate = str => {
  try {
    let arr = str ? str.split('%%') : []
    arr = arr.reduce((init, item, index) => {
      let data = item
      if (index % 2 === 1) {
        data = getDateAndTime(data)
        data = `${data[0]} ${data[1]}`
      }
      return `${init}${data}`
    }, '')
    return arr
  } catch (e) {
    console.error('error in converting date string', e)
  }
}
const classToggler = el => {
  let element = document.getElementsByTagName(el)[0]
  if (
    !checkMobileDevice() &&
    isTripDetailsPage() &&
    document.getElementsByTagName(el) &&
    document.getElementsByTagName(el).length > 1
  ) {
    [, element] = document.getElementsByTagName(el)
  }
  return element
}
export const addClassToId = (el, className) => {
  const element = classToggler(el)
  if (element.className.split(' ').indexOf(className) === -1) {
    element.className += ` ${className}`
  }
}

export const removeClassFromId = (el, className) => {
  const element = classToggler(el)
  element.className = element.className.replace(
    new RegExp(`\\b${className}\\b`, 'g'),
    ''
  )
}

export const arrDepFormatter = (dep, arr, journeyType) => {
  let returnString = ''
  
  const journeyMap = getCookie('selectedLanguage') == 'ar' ? 
    {
      R: `${arr} ${String.fromCharCode(8644)} ${dep}`,
      M: `${dep} Multicity`,
      O: `${arr} ${String.fromCharCode(8592)} ${dep}`
    } : 
    {
      R: `${dep} ${String.fromCharCode(8644)} ${arr}`,
      M: `${dep} Multicity`,
      O: `${dep} ${String.fromCharCode(8594)} ${arr}`
    }
    
  if (journeyType && journeyMap[journeyType]) {
    returnString = journeyMap[journeyType]
  }
  
  return returnString
}

export const downloadLinkCreator = (link, viewFlag = false) => {
  const anchor = document.createElement('a')
  const body = document.getElementsByTagName('body')
  anchor.setAttribute('href', link)
  if (!viewFlag) {
    anchor.setAttribute('target', '_blank')
  }
  anchor.setAttribute('rel', 'noopener noreferrer')
  body[0].append(anchor)
  anchor.click()
}

export const getTrainECateringBookingStatusText = (bookingStatus = '') => {
  const mapping = {
    P: 'PLACED',
    K: 'CANCELLED',
    D: 'DELIVERED',
    U: 'UNDELIVERED',
    H: 'PARTIALLY DELIVERED'
  }
  return (mapping[bookingStatus] || '').toUpperCase()
}

export const isEmpty = obj => {
  if (obj instanceof Date) {
    return false
  }
  // null and undefined are "empty"
  if (obj == null || obj === 'undefined') {
    return true
  }

  const isNumber = value => Object.prototype.toString.call(value) === '[object Number]'
  const isNaN = value => isNumber(value) && value.toString() === 'NaN'

  if (isNumber(obj)) {
    return isNaN(obj)
  }

  /** Assume if it has a length property with a non-zero value
   * that that property is correct.
   */
  if (obj.length > 0) {
    return false
  }
  if (obj.length === 0) {
    return true
  }

  /** If it isn't an object at this point
   * it is empty, but it can't be anything *but* empty
   * Is it empty?  Depends on your application.
   */
  if (typeof obj !== 'object') {
    return true
  }

  /**  Otherwise, does it have any properties of its own?
   * Note that this doesn't handle
   * toString and valueOf enumeration bugs in IE < 9
   */
  const keys = Object.keys(obj)
  for (let i = 0, key = keys[i]; i < keys.length; i += 1) {
    if (hasOwnProperty.call(obj, key)) {
      return false
    }
  }
  return true
}

export const validateEmail = email => {
  const reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
  if (!reg.test(email)) {
    return false
  }
  return true
}

export const validatePassword = password => {
  return !isEmpty(password)
}

export const validateMobileNumber = (mobile, minLength, maxLength) => {
  if (
    mobile &&
    mobile.length >= minLength &&
    mobile.length <= maxLength &&
    onlyNumbersRegex.test(mobile)
  ) {
    return true
  }
  return false
}

export const validateFirstName = (fname, length) => {
  if (onlyAlphabetsSpaceRegex.test(fname) && fname.length <= length) {
    return true
  }
  return false
}

export const validateLastName = (lname, length, maxLength = 32) => {
  if (
    onlyAlphabetsSpaceRegex.test(lname) &&
    lname.length >= length &&
    lname.length <= maxLength
  ) {
    return true
  }
  return false
}

export const flightDuration = time => {
  if (typeof time !== 'number') {
    return ''
  }
  const hours = Math.floor(time / 60 / 60)
  const minutes = Math.floor(time / 60) - hours * 60
  return `${hours}h ${minutes}m`
}
export const resolveKeysInObjectsArrays = (p, o) => {
  const reducerFunction = (xs, x) => {
    return xs && xs[x] ? xs[x] : null
  }
  return p.reduce(reducerFunction, o)
}

export const path = (p, o) => {
  const reducerFunction = (xs, x) => {
    return xs && xs[x] ? xs[x] : null
  }
  return p.reduce(reducerFunction, o)
}

export const isInDomain = () => {
  let retVal = false
  const domain = path(['location', 'hostname'], window)
  if (
    domain === 'www.cleartrip.com' ||
    domain === 'qa2.cleartrip.com' ||
    domain === 'qa2new.cleartrip.com' ||
    domain === '0.0.0.0' ||
    domain === 'localhost'
  ) {
    retVal = false
  }
  return retVal
}
export const isInFlyinDomain = () => {
  let retVal = false
  const domain = path(['location', 'hostname'], window)
  if (
    domain === 'www.flyin.com' ||
    domain === 'qa.flyin.com' ||
    domain === 'me.flyin.com' ||
    domain === 'eg.flyin.com' ||
    domain === 'meeg.flyin.com' ||
    domain === 'ae.flyin.com' ||
    domain === 'meae.flyin.com' ||
    domain === 'mappdcwebservices.flyin.com' ||
    domain === 'prelive.flyin.com' ||
    domain === 'localhost'
  ) {
    retVal = true
    if (getCookie('selectedLanguage') == 'ar') {
      document.title = 'فلاي إن - أفضل عروض الطيران والفنادق'
    } else {
      document.title = 'Cheap Flights, Hotels Booking, Last Minute Flights+Hotels Deals @ Flyin.com'
    }
  } else {
    document.title = 'Cleartrip Customer Support & Contact Number | Connect with us on +91 9595333333'
  }
  return retVal
}

export const getDomainAdjustedCancellationLabel = (label = '') => {
  if (!label || typeof label !== 'string') return label
  if (!isInFlyinDomain()) return label

  return label.replace(/cleartrip/ig, 'Flyin').replace(/\bCT\b/g, 'Flyin')
}

export const getTravellerObj = res => {
  let travellerObj = { title: '', fName: '', lName: '', mNo: '' }
  if (res.data) {
    let pTravellerId = -1
    if (
      res.data.user &&
      res.data.user.contact_data &&
      res.data.user.contact_data.other_details &&
      res.data.user.contact_data.other_details.length > 0
    ) {
      res.data.user.contact_data.other_details.forEach((elem, idx) => {
        if (elem.name && elem.name === 'PrimaryTraveller' && elem.value) {
          pTravellerId = parseInt(elem.value, 10)
        } else if (elem.name && elem.name === 'PrefillTravellerInfo') {
          if (elem.value) {
            travellerObj = { ...travellerObj, prefill: elem.value }
          }
          if (elem.id) {
            travellerObj = { ...travellerObj, prefillId: elem.id }
          }
        }
      })
      if (
        pTravellerId !== -1 &&
        res.data.user.people &&
        res.data.user.people.length > 0
      ) {
        res.data.user.people.forEach(elem => {
          if (elem.id && elem.id === pTravellerId) {
            if (
              elem.contact_data &&
              elem.contact_data.phone_numbers &&
              elem.contact_data.phone_numbers.length > 0 &&
              elem.contact_data.phone_numbers[0].phone_number_value
            ) {
              travellerObj = {
                ...travellerObj,
                mNo: elem.contact_data.phone_numbers[0].phone_number_value
              }
              travellerObj = {
                ...travellerObj,
                category: elem.contact_data.phone_numbers[0].category,
                contact_data_id:
                  elem.contact_data.phone_numbers[0].contact_data_id,
                country_code: elem.contact_data.phone_numbers[0].country_code,
                id: elem.contact_data.phone_numbers[0].id,
                mobile_number: elem.contact_data.phone_numbers[0].mobile_number,
                seq_no: elem.contact_data.phone_numbers[0].seq_no
              }
            }
            if (elem.personal_data) {
              if (elem.personal_data.first_name) {
                travellerObj = {
                  ...travellerObj,
                  fName: elem.personal_data.first_name
                }
              }
              if (elem.personal_data.last_name) {
                travellerObj = {
                  ...travellerObj,
                  lName: elem.personal_data.last_name
                }
              }
              if (elem.personal_data.title) {
                travellerObj = {
                  ...travellerObj,
                  title: elem.personal_data.title
                }
              }
            }
          }
        })
      }
    }
  }
  return travellerObj
}

export const getFormattedCardNumber = (num = '') => {
  let res = ''
  for (let i = 1; i <= num.length; i += 1) {
    if (num[i - 1] === 'X') {
      res += 'x'
    } else {
      res += num[i - 1]
    }
    if (i % 4 === 0) {
      res += ' '
    }
  }
  return res
}

export const getSCLPwalletState = alternateRefund => {
  if (Array.isArray(alternateRefund.alternateRefundMode) &&
    alternateRefund.alternateRefundMode.includes('WALLET')) {
    if (alternateRefund.mobileDetails &&
      alternateRefund.mobileDetails.mobile &&
      alternateRefund.mobileDetails.countryCode
    ) {
      return 'WALLET_NOT_CREATED'
    }
    return 'WALLET_CREATED'
  }
  return 'WALLET_NOT_AVAILABLE'
}

export const isSessionStorageValid = () => {
  return (
    window && window?.sessionStorage && window?.sessionStorage !== ' undefined'
  )
}

export const isMobileSite = () => {
  let isApp = false
  if (path(['androidData', 'app-agent'], window)) {
    isApp = true
  }

  if (path(['iosData', 'app-agent'], window)) {
    isApp = true
  }
  return isApp
}

export function delete_cookie(name) {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}

export function getCookie(name) {
  if (path(['cookie'], document)) {
    const nameEQ = `${name}=`
    const ca = document.cookie.split(';')
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
    }
    return ''
  }
  return ''
}

export const checkDeviceType = () => {
  let deviceType = null
  if (
    path(['androidData', 'app-agent'], window) &&
    path(['androidData', 'js-version'], window)
  ) {
    deviceType = 'AndroidApp'
  }
  if (
    path(['iosData', 'app-agent'], window) &&
    path(['iosData', 'js-version'], window)
  ) {
    deviceType = 'iPhoneApp'
  }
  if (
    path(['sessionStorage'], window) &&
    typeof window.sessionStorage !== 'undefined'
  ) {
    deviceType = sessionStorage.getItem('mobileApp')
  }
  return deviceType
}
export function invokeCustomEvent(EVENT_TYPE, obj) {
  const customEvent = new CustomEvent(EVENT_TYPE, { detail: { ...obj } })
  document.dispatchEvent(customEvent)
}

export const donwloadPDFwithByteCode = (byteString, pdfName) => {
  const arrayBuffer = new ArrayBuffer(byteString.length)
  const int8Array = new Uint8Array(arrayBuffer)
  for (let i = 0; i < byteString.length; i += 1) {
    int8Array[i] = byteString.charCodeAt(i)
  }

  const blob = new Blob([int8Array], { type: 'application/pdf' })
  const fileURL = window.URL.createObjectURL(blob)

  const alink = document.createElement('a')
  alink.href = fileURL
  alink.download = pdfName
  alink.click()
}

export const setCookie = (name, value, days) => {
  let expires
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = `; expires=${date.toGMTString()}`
  } else {
    expires = ''
  }
  document.cookie = `${name}=${value}${expires}; path=/`
}

export const DOMAIN =
  process.env.CT_ENV === 'development' ?
    'http://localhost:3032' :
    window.location.origin || 'https://www.cleartrip.com'

export function sendSigninDeviceIdNativeAndroidCallback() {
  if (path(['androidData', 'app-agent'], window) && path(['androidData', 'js-version'], window)) {
    window?.MobileApp?.saveDeviceIdCookie(
      JSON.stringify({
        cookie_value: 'ct-dvId'
      })
    )
  }
}

export function sendSigninDeviceIdNativeIosCallback() {
  if (path(['iosData', 'app-agent'], window) && path(['iosData', 'js-version'], window)) {
    window?.webkit?.messageHandlers.saveDeviceIdCookie?.postMessage({
      cookie_value: 'ct-dvId'
    })
  }
}

export function sendSignoutNativeAndroidCallback() {
  if (path(['androidData', 'app-agent'], window) && path(['androidData', 'js-version'], window)) {
    window?.MobileApp?.onPWALoginStatus(
      JSON.stringify({
        isSignIn: false
      })
    )
  }
}
export function sendSignoutNativeIosCallback() {
  if (path(['androidData', 'app-agent'], window) && path(['androidData', 'js-version'], window)) {
    window?.webkit?.messageHandlers.PWA_IS_SIGNIN.postMessage({
      isSignIn: false
    })
  }
}

export const isMsiteInAppWebview = () => {
  const params = new Proxy(new URLSearchParams(path(['location', 'search'], window)), {
    get: (searchParams, prop) => searchParams.get(prop),
  })
  const userAgent = path(['navigator', 'userAgent'], window)?.toLowerCase()
  const safari = /safari/.test(userAgent) // checks if website is running in any browser in apple device
  const ios = /iphone|ipod|ipad/.test(userAgent) // checks if device is among iphone, ipad or ipod

  if (params.isMobileApp === 'true' || // checks if query parameters have isMobileApp = true
    (ios && !safari) || // checks if device is of ios but not running in browser
    path(['androidData', 'app-agent'], window) || // checks android data
    path(['iosData', 'app-agent'], window) || // checks ios data
    (path(['sessionStorage', 'mSiteInAppWebview'], window) === 'true')) { // checks session storage
    if (path(['sessionStorage'], window)) {
      window.sessionStorage.setItem('mSiteInAppWebview', 'true')
    }
    return true
  }
  return false
}

export const isMobileSiteJSversion = (jsVersion = 1) => {
  let isApp = false
  if (path(['androidData', 'app-agent'], window) &&
    path(['androidData', 'js-version'], window) &&
    (path(['androidData', 'js-version'], window) >= jsVersion)) {
    isApp = true
  }

  if (path(['iosData', 'app-agent'], window) &&
    path(['iosData', 'js-version'], window) &&
    path(['iosData', 'js-version'], window) >= jsVersion) {
    isApp = true
  }
  return isApp
}
